export const DocumentTypes = {
  ATTACHMENT: 'ATTACHMENT',
  SOURCE: 'SOURCE',
}
